import ManAndChildLove from "assets/images/jpgs/ManAndChildLove.jpg";
import AboutUsInfo from "features/HomePage/components/AboutUsInfo";
import { Link } from "react-router-dom";
import Button from "shared/Button";
import { ABOUTPAGESECTIONONE } from "utilities/data";

const SectionOne = () => {
  return (
    <div className="px-16 max-[450px]:px-4 py-16 max-md:flex-wrap justify-center flex gap-12">
      <div className="h-[500px]">
        <img
          className="w-full h-full object-cover"
          src={ManAndChildLove}
          alt="AboutImage"
        />
      </div>
      <div className="md:w-1/2">
        <AboutUsInfo
          header={ABOUTPAGESECTIONONE.header}
          body={ABOUTPAGESECTIONONE.body}
          extraBody={ABOUTPAGESECTIONONE.extraBody}
          buttonText={ABOUTPAGESECTIONONE.buttonText}
          textColor="text-[#7A7A7A]"
        />
        <Link to="/projects">
          <Button textColor="text-[#011F5B]" className="bg-white">
            JOIN THE CAUSE
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SectionOne;
